{
  "messages": {
    "processing": "Processing file...",
    "dragHere": "Drag your SVG here."
  }
}
